import Vue from 'vue';
import App from './App.vue';
import store from './store';
import i18n from './localization/i18n';
import URLS from './URLS';

// Configure Bootstrap
import {
    BadgePlugin,
    ImagePlugin,
    ListGroupPlugin,
    ProgressPlugin,
    CollapsePlugin,
    NavbarPlugin,
    LinkPlugin,
    TooltipPlugin,
    CarouselPlugin,
} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';

Vue.use(BadgePlugin);
Vue.use(ImagePlugin);
Vue.use(ListGroupPlugin);
Vue.use(ProgressPlugin);
Vue.use(CollapsePlugin);
Vue.use(NavbarPlugin);
Vue.use(LinkPlugin);
Vue.use(TooltipPlugin);
Vue.use(CarouselPlugin);

// Configure Device
import Device from 'vue-device-detector';
Vue.use(Device);

// Configure Font Awesome Icons
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Register Font Awesome Icons
import { library } from '@fortawesome/fontawesome-svg-core';
import faRegistrator from './faRegistrator';
faRegistrator(library);

// Configure VueScrollTo
import VueScrollTo from 'vue-scrollto';
Vue.use(VueScrollTo, {
    duration: 500,
    easing: 'ease-in-out',
    offset: -80,
    force: true,
    cancelable: true,
    x: false,
    y: true,
});

// Configure VueSafeHTML
import VueSafeHTML from 'vue-safe-html';
Vue.use(VueSafeHTML);

// Configure CSS
import './assets/css/global.css';
import './assets/css/theme.css';
import './assets/css/animations.css';
import './config/custom.css';

// Configure global components
import registerComponents from './compConfiguration';
registerComponents();

// Configure refresh token middleware
import '~/store/middlewares/refreshToken';

import router from './router';

GTM.init(router);

// Configure AnalyticService
import AnalyticService from './services/AnalyticService';
import GTM from './utils/gtm/GTM';
AnalyticService.initialize();

Vue.config.productionTip = false;
Vue.prototype.$URLS = URLS;

export default new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');
